<template>
  <div>
    <div v-show="$store.state.operate!='添加'&&$store.state.operate!='编辑'&&$store.state.operate!='详情'&&$store.state.operate!='复制'" class="page-list">
	<com-page-title  @callbackOperate="callbackOperate" ></com-page-title>
	  <!-- 搜索栏 -->
	<el-form :inline="true"  class="demo-form-inline">
		<el-form-item label="">
				 <el-select v-model="form.status" clearable @change="callbackIndex(1)" placeholder="状态">
						 <el-option
						   v-for="item in statusList"
						   :key="item.value"
						   :label="item.text"
						   :value="item.value">
						 </el-option>
				   </el-select>
				</el-form-item>
				
				
				<el-form-item label="">
						  <el-input clearable  @clear="callbackIndex(1)" v-model="form.code"  @change="callbackIndex(1)"
				placeholder="编码"></el-input>
						</el-form-item>
						<!-- <el-form-item label="">
								  <el-input clearable  @clear="callbackIndex(1)" v-model="form.codeExt"  @change="callbackIndex(1)"
						placeholder="用户编码"></el-input>
								</el-form-item> -->
						<el-form-item label="">
								  <el-input clearable  @clear="callbackIndex(1)" v-model="form.tel"  @change="callbackIndex(1)"
						placeholder="手机号"></el-input>
								</el-form-item>
		<el-form-item  label="">
		    <el-date-picker prefix-icon="none"
		         v-model="form.dateRange" :editable="false"
		         type="datetimerange"
				 value-format='yyyy-MM-dd HH:mm:ss'
				  start-placeholder="开始时间"
				       end-placeholder="结束时间"
		         range-separator=""
				   @change="callbackIndex(1)">
		       </el-date-picker>
		  </el-form-item>
		   <el-form-item label="">
		 <el-button @click="callbackIndex(1)" type="primary">搜索</el-button>
		  </el-form-item>
		</el-form>
		
      <el-table
        :data="pageData"
        highlight-current-row
        style="width: 100%;"
		:height="$store.state.height-328"
		ref="multipleTable"
		@select-all="selectChange"
		@select="selectChange"
		@sort-change="sortChange">
	   <template slot="empty"><el-empty description="暂时没有数据"></el-empty> </template>
		      <el-table-column type="selection"></el-table-column>
		   <com-page-index></com-page-index>
		   <el-table-column prop='code' width="200" label='编码' ></el-table-column>
		    <el-table-column prop='statusText' label='状态' ></el-table-column>
			<el-table-column prop='payCode' width="200" label='支付号' ></el-table-column>
			<!-- <el-table-column prop='payName' width="200" label='支付方式' ></el-table-column> -->
			<el-table-column prop='recTimes' width="200" label='服务日期' ></el-table-column>
			<el-table-column prop='recTel'  label='手机号' ></el-table-column>
			<el-table-column prop='recAddress'  label='地址' ></el-table-column>
			<!-- <com-page-imgurl :isAvatarUrl="true" column='avatarUrl' title='头像' ></com-page-imgurl>
			<el-table-column prop='nickName' label='昵称' ></el-table-column> -->
			 <!-- <el-table-column prop='codeExt' label='用户编码' ></el-table-column> -->
			 <el-table-column prop='costPrice' label='金额' ></el-table-column>
			  <el-table-column prop='title' label='产品' ></el-table-column>
			  <com-page-imgurl  column='imgurlArray' label='图片' ></com-page-imgurl>
		 <el-table-column prop='createTime' label='创建时间' ></el-table-column>
		
		 <!-- 操作按钮 -->
		<com-page-operate :columnList="columnList"  :pageData="pageData" @callbackOperate="callbackOperate"></com-page-operate>
      </el-table>
	    <!-- 分页页面 -->
	  <com-page-number @callbackOperate="callbackOperate" @callbackIndex="callbackIndex" ></com-page-number>
    </div>
	<!-- 表单页面 -->
    <div v-if="$store.state.operate=='添加'||$store.state.operate=='编辑'||$store.state.operate=='详情'||$store.state.operate=='复制'"> 
      <edit  @callbackPage="callbackPage"   :id="id"></edit>
    </div>
	<!-- 返回按钮 -->
	<com-page-return @callbackPage="callbackPage" v-if="$store.state.operate=='添加'||$store.state.operate=='编辑'||$store.state.operate=='详情'||$store.state.operate=='复制'"></com-page-return>
	<!-- 导入页面 -->
	<com-page-import @callbackImport="callbackImport"  v-if="$store.state.operate=='导入'"></com-page-import>
	<!-- 导出页面 -->
	<com-page-export  v-if="$store.state.operate=='导出'"></com-page-export>
 <!-- 账号配置列 -->
	<com-page-columns  @callbackColumns="callbackColumns"  v-if="$store.state.operate=='配置列'"></com-page-columns>
 </div>
</template>
<script>
import edit from "@/components/edit/com-edit-orders"; 
export default {
  components: {edit },
  data() {
    return {
		statusList:[ {value: 10, text: "待支付"}, {value: 20, text: "已支付"}, {value: 30, text: "待收货"}, {value: 40, text: "已完成"},
		{value: 100, text: "已退款"}],
	columnList:[],//权限列
		pageData:[],//页面数据
		id:'',//表单主键id
		form:{//搜索表单
			dateRange: this.$dateRangeCurrent,//时间
			code:'',//编码
					status:'',//状态
					recName:'',//联系人
					recTel:'',//手机号
					types:'',
					codeExt:''
		},
    };
  },
   watch: {
      $route(to,from){ //路由监听
	   this.form.dateRange=this.$dateRangeCurrent;
	    this.form.code='';//编码
		this.form.types='';
	   		 this.form.status='';//状态
	   		 this.form.recName='';//联系人
	   		 this.form.recTel='';//手机号
	    this.callbackIndex(1)
        }
     },
  methods: {
   callbackImport(){//导入回调
		   this.callbackIndex(1)
	  },
	   selectChange(selection,row){//选择
	  this.$store.commit("saveSelect", selection);
	  },
	  sortChange(column){//排序回调
		var list= this.$store.state.list;
		list.pageOrder=column.order == 'descending'?'desc':'asc';
		list.pageSort=column.prop;
		this.$store.commit("saveList", list);
		 this.callbackIndex(1)
	},
	  callbackOperate(e){//操作按钮事件
		  if(e.operate=='添加')
			  this.id="";
		   if(e.operate=='复制'||e.operate=='编辑'||e.operate=='详情')
			  this.id=(e.data.id||'').toString();
		if(e.operate=='删除'){
		var id=this.$store.state.select.map(item=>item.id).join(',');
		 localStorage.setItem('SELECTIDS',id)
				this.$axios.post(`/api/Orders/PostOrdersDeleteWhere` ,'').then(e => {
					 this.$message.success('删除成功到同步服务器');
							this.callbackIndex(this.pageIndex);
				  }); 
		}
	  },
	  callbackPage(e){//表单返回事件
		  if(e.statusText=='添加'||e.statusText=='编辑'){
		    this.$store.commit("saveOperate", "");
			   this.$message.success('提交成功同步到服务器');
			this.callbackIndex(1);
		  }
	  },
    callbackIndex(i) {//获取分页数据
       var data=this.$pageParams(this.form,i)
      this.$axios.get(`/api/Orders/GetOrdersPage`,data).then(e => {
		 this.$store.commit("saveList", e);
			this.pageData=e.pageData;
        });
    }
  },
  mounted() {//页面加载事件
   this.form.types=this.$route.query.types||'';
     this.$store.commit("saveList", {});
   this.callbackIndex(1)  
  
  }
  
};
</script>
<style>
</style>

